module.exports = __webpack_public_path__ + "static/media/subscription-section-6.d8d38104.png";